import { graphql } from "relay-runtime"
import { useBetterDocMutation } from "@/modules/admin/better-doc/hooks/useBetterDocMutation"
import { useSendBetterDocTestCaseMutation as useSendBetterDocTestCaseMutationType } from "@/modules/admin/better-doc/services/__generated__/useSendBetterDocTestCaseMutation.graphql"

const mutation = graphql`
  mutation useSendBetterDocTestCaseMutation($input: De_sendBetterDocTestCaseInput!) {
    de_sendBetterDocTestCase(input: $input) {
      testCaseResult: de_BetterDocTestCaseResult {
        sessionId
        partnerSessionId
        insuranceCountry
        outcome
        httpStatusCode
        betterDocState
        caseId
        recommendationId
        errorReason
      }
    }
  }
`

export type BetterDocTestCaseResult = NonNullable<
  useSendBetterDocTestCaseMutationType["response"]["de_sendBetterDocTestCase"]["testCaseResult"]
>

export const useSendBetterDocTestCaseMutation = () => {
  return useBetterDocMutation<useSendBetterDocTestCaseMutationType>(mutation)
}
